import React, { useState, useEffect } from 'react';
import './HomePage.css';
import { ReactComponent as Logo } from '../../assets/logo-1g2n.svg';

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const hideModal = () => setIsModalOpen(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  useEffect(() => {
    // Smooth scrolling for navigation links
    const handleSmoothScroll = (e) => {
      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#') && href.length > 1) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', handleSmoothScroll);
    });

    // Navbar scroll effect
    let lastScrollTop = 0;
    const navbar = document.querySelector('.navbar');
    
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 100) {
        navbar.style.backgroundColor = 'rgba(85, 107, 47, 0.95)';
        navbar.style.backdropFilter = 'blur(10px)';
      } else {
        navbar.style.backgroundColor = 'var(--primary-green)';
        navbar.style.backdropFilter = 'none';
      }
      
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        navbar.style.transform = 'translateY(-100%)';
      } else {
        navbar.style.transform = 'translateY(0)';
      }
      
      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener('click', handleSmoothScroll);
      });
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    
    // Simulate API call
    setTimeout(() => {
      hideModal();
      showWelcomeMessage(data.fullName);
      e.target.reset();
    }, 2500);
  };



  const showWelcomeMessage = (name) => {
    const welcomeDiv = document.createElement('div');
    welcomeDiv.innerHTML = `
      <div style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 3rem;
        border-radius: 20px;
        box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        z-index: 3000;
        text-align: center;
        max-width: 500px;
        width: 90%;
      ">
        <div style="font-size: 3rem; margin-bottom: 1rem;">🎉</div>
        <h3 style="color: var(--primary-green); margin-bottom: 1rem; font-family: Georgia, serif;">Welcome to the Family, ${name}!</h3>
        <p style="color: var(--text-medium); margin-bottom: 2rem; line-height: 1.6;">
          Your family's digital legacy space is being prepared. Check your email for next steps to start sharing your precious stories and memories.
        </p>
        <button onclick="this.closest('div').remove()" style="
          background: var(--primary-green);
          color: white;
          padding: 1rem 2rem;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          font-weight: bold;
        ">Let's Get Started!</button>
      </div>
    `;
    
    const backdrop = document.createElement('div');
    backdrop.style.cssText = `
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      background: rgba(0,0,0,0.6);
      z-index: 2999;
    `;
    
    document.body.appendChild(backdrop);
    document.body.appendChild(welcomeDiv);
    
    setTimeout(() => {
      welcomeDiv.remove();
      backdrop.remove();
    }, 8000);
  };



  return (
    <>
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <a href="#" className="logo">
            <Logo className="logo-svg" />
          </a>
          <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <li><a href="#home">Home</a></li>
            <li><a href="#stories">Stories</a></li>
            <li><a href="#features">Features</a></li>
            <li><a href="#how-it-works">How It Works</a></li>
            <li><a href="/login" className="nav-link">Login</a></li>
            <li><a href="/auth/register" className="cta-button">Join Our Family</a></li>
          </ul>
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>☰</button>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-container">
          <h1 className="fade-in-up">Every Family Has Stories Worth Sharing</h1>
          <p className="fade-in-up">Connect hearts across generations through the wisdom, memories, and love that make your family unique</p>
                      <a href="/auth/register" className="cta-button fade-in-up heartbeat">Start Sharing Your Stories</a>
        </div>
      </section>

      {/* Family Stories Section */}
      <section id="stories" className="family-stories">
        <div className="homepage-container">
          <h2 className="section-title">Real Families, Real Stories</h2>
          <p className="section-subtitle">"The stories we share today become the treasures of tomorrow"</p>
          
          <div className="family-grid">
            <div className="family-story">
              <div className="family-photo grandma"></div>
              <div className="story-content">
                <h3 className="story-title">Grandma's Secret Recipe</h3>
                <p className="story-text">"I finally convinced Grandma Rose to share her famous apple pie recipe. But more than ingredients, she shared the story of how she learned it from her mother during the Great Depression..."</p>
                <p className="story-author">— Shared by Jennifer, age 52</p>
              </div>
            </div>

            <div className="family-story">
              <div className="family-photo grandpa"></div>
              <div className="story-content">
                <h3 className="story-title">Dad's First Job Advice</h3>
                <p className="story-text">"When my grandson asked about starting his career, I recorded a video sharing what I learned from 40 years as a carpenter. The look in his eyes when he watched it was priceless..."</p>
                <p className="story-author">— Shared by Robert, age 74</p>
              </div>
            </div>

            <div className="family-story">
              <div className="family-photo family"></div>
              <div className="story-content">
                <h3 className="story-title">Family Traditions Live On</h3>
                <p className="story-text">"Our weekly Sunday dinners created some of our best memories. Now my grandchildren are continuing the tradition with their own families, 2,000 miles away..."</p>
                <p className="story-author">— Shared by Maria, age 68</p>
              </div>
            </div>

            <div className="family-story">
              <div className="family-photo cooking"></div>
              <div className="story-content">
                <h3 className="story-title">Lessons from the Kitchen</h3>
                <p className="story-text">"Teaching my daughter to cook wasn't just about food—it was about patience, love, and creating something beautiful together. Now she's teaching her daughter the same lessons..."</p>
                <p className="story-author">— Shared by Dorothy, age 81</p>
              </div>
            </div>

            <div className="family-story">
              <div className="family-photo reading"></div>
              <div className="story-content">
                <h3 className="story-title">Bedtime Stories and Life Lessons</h3>
                <p className="story-text">"Every night, I'd tell my children stories about when I was young. Now they're sharing those same stories with their children, keeping our family history alive..."</p>
                <p className="story-author">— Shared by William, age 79</p>
              </div>
            </div>

            <div className="family-story">
              <div className="family-photo garden"></div>
              <div className="story-content">
                <h3 className="story-title">Garden Wisdom</h3>
                <p className="story-text">"My grandfather taught me that gardens, like families, need patience, care, and time to grow. I'm passing on both his gardening tips and his life philosophy to my grandchildren..."</p>
                <p className="story-author">— Shared by Eleanor, age 72</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="homepage-container">
          <div className="features-intro">
            <h2>Simple Ways to Share What Matters Most</h2>
            <p>Our platform makes it easy for families to capture, organize, and share the stories that connect generations</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🌳</div>
              <h3>Your Family Tree</h3>
              <p>Build a living family tree where each person's story, photos, and memories create a rich tapestry of your heritage</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>Easy Story Recording</h3>
              <p>Record stories with your phone, tablet, or computer. Add photos, videos, and voice recordings to bring memories to life</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💝</div>
              <h3>Private Family Sharing</h3>
              <p>Share stories safely within your family circle. Control who sees what, and keep precious memories secure and private</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🎵</div>
              <h3>Wisdom Collections</h3>
              <p>Organize life lessons into easy-to-find collections: "Advice for Marriage," "Career Wisdom," "Family Recipes" and more</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📮</div>
              <h3>Future Messages</h3>
              <p>Write letters to be delivered on special future dates—birthdays, graduations, weddings—your love arrives exactly when needed</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🗣️</div>
              <h3>Preserve Your Voice</h3>
              <p>Keep the sound of your voice forever, so future generations can hear your stories in your own words, your own tone</p>
            </div>
          </div>
        </div>
      </section>

      {/* Special Features */}
      <section className="special-features">
        <div className="homepage-container">
          <div className="special-intro">
            <h2>Features You Won't Find Anywhere Else</h2>
            <p>We've created unique ways to connect families that go far beyond simple photo sharing</p>
          </div>
          
          <div className="special-grid">
            <div className="special-feature">
              <h4>🎵 Life Lesson Playlists</h4>
              <p>Create themed collections of your wisdom: "My Rules for Love," "What I Learned Starting a Business," "Cooking Secrets from My Mother." Organize your advice like a playlist of life's greatest hits.</p>
              <span className="special-badge">Only Here</span>
            </div>
            
            <div className="special-feature">
              <h4>💭 Ask Grandpa/Grandma</h4>
              <p>Family members can ask you specific questions: "What would you do if your best friend betrayed you?" Record personalized video responses that provide real guidance for real situations.</p>
              <span className="special-badge">Only Here</span>
            </div>
            
            <div className="special-feature">
              <h4>📦 Time Capsule Letters</h4>
              <p>Write messages that will be delivered automatically on future birthdays, graduations, or anniversaries. Your wisdom and love, arriving exactly when your family needs it most.</p>
              <span className="special-badge">Only Here</span>
            </div>
            
            <div className="special-feature">
              <h4>🌿 "What If" Stories</h4>
              <p>Explore the paths not taken: "If I hadn't joined the Navy..." "If we hadn't moved to California..." Share alternative storylines that show how different choices shaped your life.</p>
              <span className="special-badge">Only Here</span>
            </div>
            
            <div className="special-feature">
              <h4>🎮 Family Challenges</h4>
              <p>Turn legacy-building into fun family activities: "Teach someone your signature recipe," "Interview a sibling about childhood," "Share your most embarrassing mistake and what you learned."</p>
              <span className="special-badge">Only Here</span>
            </div>
            
            <div className="special-feature">
              <h4>🔗 Story Connections</h4>
              <p>Link family heirlooms, recipes, and treasured objects to their stories. When someone sees grandma's wedding ring, they can instantly access the story of how grandpa proposed.</p>
              <span className="special-badge">Only Here</span>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <div className="homepage-container">
          <h2 className="section-title">What Families Are Saying</h2>
          
          <div className="testimonials-grid">
            <div className="testimonial">
              <p className="testimonial-text">I wish I had this when my parents were still alive. Now I'm making sure my grandchildren will have all my stories, recipes, and life lessons forever. It's the most meaningful gift I can give them.</p>
              <div className="testimonial-author">
                <div className="author-photo sarah"></div>
                <div className="author-info">
                  <h5>Sarah Johnson</h5>
                  <p>Grandmother of 8, Age 73</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial">
              <p className="testimonial-text">My dad started sharing stories about his childhood in Ireland. Hearing his voice tell these tales is bringing our whole family closer together. My kids ask to listen to 'Grandpa's stories' every night.</p>
              <div className="testimonial-author">
                <div className="author-photo michael"></div>
                <div className="author-info">
                  <h5>Michael O'Brien</h5>
                  <p>Father of 3, Age 42</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial">
              <p className="testimonial-text">The time capsule feature is incredible. I wrote letters to each of my grandchildren to be delivered on their 18th birthdays. Knowing my words will be there for their big moments gives me such peace.</p>
              <div className="testimonial-author">
                <div className="author-photo robert"></div>
                <div className="author-info">
                  <h5>Robert Chen</h5>
                  <p>Grandfather of 5, Age 78</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial">
              <p className="testimonial-text">My grandmother's voice is preserved forever now. When I'm having a tough day, I can listen to her telling stories about overcoming hardships. It's like she's still here guiding me.</p>
              <div className="testimonial-author">
                <div className="author-photo emily"></div>
                <div className="author-info">
                  <h5>Emily Rodriguez</h5>
                  <p>Granddaughter, Age 28</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial">
              <p className="testimonial-text">We use the family challenges to bring everyone together. Last month's challenge was to share a childhood recipe. We had the most amazing virtual cooking session with four generations!</p>
              <div className="testimonial-author">
                <div className="author-photo angela"></div>
                <div className="author-info">
                  <h5>Angela Washington</h5>
                  <p>Family Organizer, Age 55</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial">
              <p className="testimonial-text">The wisdom playlists are perfect. I created one called 'Lessons from 40 Years of Marriage' for my children. It's like leaving them a roadmap for their own relationships.</p>
              <div className="testimonial-author">
                <div className="author-photo frank"></div>
                <div className="author-info">
                  <h5>Frank Peterson</h5>
                  <p>Married 42 years, Age 69</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="how-it-works">
        <div className="homepage-container">
          <h2 className="section-title">Getting Started is Simple</h2>
          <p className="section-subtitle">You don't need to be tech-savvy to share your family's most precious stories</p>
          
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h4>Create Your Family Circle</h4>
              <p>Start by inviting your children, grandchildren, and close family members to join your private family network</p>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <h4>Begin Sharing Stories</h4>
              <p>Use our simple tools to record stories, upload photos, and create your family tree. Start with just one special memory</p>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <h4>Organize Your Wisdom</h4>
              <p>Create life lesson playlists, answer family questions, and set up time capsule messages for future special occasions</p>
            </div>
            
            <div className="step">
              <div className="step-number">4</div>
              <h4>Watch Your Legacy Grow</h4>
              <p>As more family members join and share, your family's story becomes richer, deeper, and more meaningful every day</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="homepage-container">
          <div className="cta-content">
            <h2>Your Family Story Starts Today</h2>
            <p>Join thousands of families who are creating lasting legacies of love, wisdom, and connection for future generations</p>
                            <a href="/auth/register" className="cta-button-large">Start Your Family's Story</a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="homepage-container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>For Families</h4>
              <ul>
                <li><a href="#">Getting Started</a></li>
                <li><a href="#">Story Ideas</a></li>
                <li><a href="/privacy">Privacy & Security</a></li>
                <li><a href="#">Family Challenges</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><a href="#">Help Center</a></li>
                <li><a href="#">Video Tutorials</a></li>
                <li><a href="#">Contact Us</a></li>
                <li><a href="#">Community Forum</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>About Us</h4>
              <ul>
                <li><a href="#">Our Story</a></li>
                <li><a href="#">Why We Built This</a></li>
                <li><a href="#">Press & Media</a></li>
                <li><a href="#">Careers</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Connect With Us</h4>
              <ul>
                <li><a href="#">Facebook Community</a></li>
                <li><a href="#">Instagram Stories</a></li>
                <li><a href="#">Family Blog</a></li>
                <li><a href="#">Newsletter</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} One Generation to Next. Made with ❤️ for families everywhere. | <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a></p>
          </div>
        </div>
      </footer>

      {/* Signup Modal */}
      {isModalOpen && (
        <div className="modal" onClick={hideModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Join Our Family Community</h3>
            <p>Start creating your family's digital legacy today. It's free to begin, and your stories will last forever.</p>
            
            <form onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label htmlFor="fullName">Your Name</label>
                <input type="text" id="fullName" name="fullName" required placeholder="e.g., Margaret Smith" />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" name="email" required placeholder="your.email@example.com" />
              </div>
              
              <div className="form-group">
                <label htmlFor="role">I am a...</label>
                <select id="role" name="role" required>
                  <option value="">Please select</option>
                  <option value="grandparent">Grandparent/Elder</option>
                  <option value="parent">Parent</option>
                  <option value="adult-child">Adult Child</option>
                  <option value="family-organizer">Family Organizer</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="familySize">About how many people are in your family?</label>
                <select id="familySize" name="familySize">
                  <option value="">Optional</option>
                  <option value="small">5-10 people</option>
                  <option value="medium">11-25 people</option>
                  <option value="large">26-50 people</option>
                  <option value="very-large">50+ people</option>
                </select>
              </div>
              
              <div className="form-buttons">
                <button type="button" className="btn-secondary" onClick={hideModal}>Maybe Later</button>
                <button type="submit" className="btn-primary">Start Our Family Story</button>
              </div>
            </form>
          </div>
        </div>
      )}


    </>
  );
};

export default HomePage;